
export function isScrape (n) {
  if (n.metaData.type.indexOf('ScreenScraped') === -1) return false
  if (n.metaData.content.trim().indexOf('{"C') !== 0) return false
  return true
}

export function parseScrape (content) {
  return JSON.parse(content)
}